import * as Yup from "yup";

export const distributorTypeSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  keyValue: Yup.string().required("Campo requerido"),
});
